import { Box } from '@mui/material';
import CoinButton from 'components/atoms/CoinButton';
import { NftType } from 'interfaces/NftData.interface';
import { OtrType } from 'interfaces/OtrData.interface';
import React, { SetStateAction } from 'react';
const pianoIcon = require('assets/piano.png');
const wrenchIcon = require('assets/wrench-small.png');
const monsterIcon = require('assets/monster.png');
const paintIcon = require('assets/paint.png');
const starsIcon = require('assets/stars.png');
const domainIcon = require('assets/domain.png');
const cameraIcon = require('assets/camera.png');
const basketballIcon = require('assets/basketball.png');

interface ICategoriesProps {
  categories: (NftType | OtrType)[];
  setCategories: SetStateAction<any>;
}

const Categories: React.FC<ICategoriesProps> = ({
  categories,
  setCategories,
}) => {
  const onClick = (category: NftType | OtrType) => {
    if (categories.includes(category))
      setCategories(categories.filter(cat => cat !== category));
    else setCategories((prev: (NftType | OtrType)[]) => [...prev, category]);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '15px',
        justifyContent: 'center',
      }}
    >
      <CoinButton
        img={pianoIcon}
        onClick={() => onClick(NftType.trading)}
        text={'Trading Cards'}
      />
      <CoinButton
        img={wrenchIcon}
        onClick={() => onClick(NftType.utility)}
        text={'Utility'}
      />
      <CoinButton
        img={monsterIcon}
        onClick={() => onClick(NftType.virtual | OtrType.virtual)}
        text={'Virtual World'}
      />
      <CoinButton
        img={paintIcon}
        onClick={() => onClick(NftType.art | OtrType.art)}
        text={'Art'}
      />
      <CoinButton
        img={starsIcon}
        onClick={() => onClick(NftType.collectibles | OtrType.collectibles)}
        text={'Collectibles'}
      />
      <CoinButton
        img={domainIcon}
        onClick={() => onClick(NftType.domains | OtrType.domains)}
        text={'Domain Names'}
      />
      <CoinButton
        img={pianoIcon}
        onClick={() => onClick(NftType.music | OtrType.music)}
        text={'Music'}
      />
      <CoinButton
        img={cameraIcon}
        onClick={() => onClick(NftType.photography | OtrType.photography)}
        text={'Photography'}
      />
      <CoinButton
        img={basketballIcon}
        onClick={() => onClick(NftType.sports | OtrType.sports)}
        text={'Sports'}
      />
    </Box>
  );
};

export default Categories;
